import styled from "styled-components";
export const Content = styled.button`
  width: 175px;
  height: 45px;
  background-color: ${({ theme }) => theme.colors.secondary10};
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
`;
